module.exports = __webpack_public_path__ + "img/antes_despues_265.de7ac858.png";